import { AsyncPipe } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CmsService, TranslatePipe } from '@spartacus/core';
import { CmsComponentData, MediaComponent } from '@spartacus/storefront';
import { combineLatest, Observable } from 'rxjs';
import { distinctUntilChanged, filter, map, switchMap, take } from 'rxjs/operators';
import { NewsCategoryPayload, NewsService } from 'src/app/service/news/news.service';
import { RemoveImageTitleAttrDirective } from '../../../../shared/remove-title-attr.directive';
import { SafeHtmlPipe } from '../../../../shared/safe-html.pipe';

@Component({
  selector: 'app-news-article',
  templateUrl: './news-article.component.html',
  styleUrls: ['./news-article.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [RouterLink, MediaComponent, RemoveImageTitleAttrDirective, AsyncPipe, TranslatePipe, SafeHtmlPipe],
})
export class NewsArticleComponent implements OnInit {
  data$: Observable<any[]> = this.componentData.data$;
  cat: string;

  constructor(
    protected componentData: CmsComponentData<any>,
    public cmsService: CmsService,
    private newsService: NewsService
  ) {}

  currentPage$: Observable<any> = this.cmsService.getCurrentPage().pipe(
    filter(Boolean),
    map((d: any) => d),
    distinctUntilChanged()
  );

  category$: Observable<any> = combineLatest([this.currentPage$]).pipe(
    switchMap(([data]) => this.getCategory(data.pageId))
  );

  private getCategory(pageId: string): Observable<any> {
    const categoryPayload: NewsCategoryPayload = {
      newsPageId: pageId,
    };
    return this.newsService.getNewsCategory(categoryPayload).pipe(
      filter(Boolean),
      map((data) => data)
    );
  }

  ngOnInit() {
    this.data$.pipe(take(1)).subscribe((data) => data);
  }
}
